cv.PublicMembersRowView = Marionette.LayoutView.extend({
  tagName: "a",
  className: "member result",
  template: cv.Templates["public/members/members_row"],

  events: {},

  templateHelpers: function () {
    return {
      name: this.model.get("display_name"),
      meta:
        cv.formatMoney({
          amount: this.model.get("stats.display_funds_raised"),
          show_sign: true,
          currency_code: this.model.get("campaign.currency_code"),
          decimal_places: 0,
        }) + " Raised",
      photo_path: cv.photo({
        photo_path: this.model.get("user.profile.avatar_image"),
        photo_default: this.model.get("campaign.default_project_image"),
        transforms: {
          fit: "crop",
        },
        url_only: true,
      }),
    };
  },

  initialize: function (options) {
    console.log("PublicMembersRowView initialized");
  },

  onShow: function () {
    imgix.fluid(this.$el.get(0), {
      rootNode: this.$el.get(0),
      updateOnResizeDown: false,
      autoInsertCSSBestPractices: true,
    });

    this.$el.attr("href", "/" + this.model.get("stub"));
  },
});
